import * as actionTypes from "./actionTypes";
import axios from "../../axios-amps";
import { sortByOrder } from "../../utils";
import { logFirebaseEvent } from "../../shared/utility";
import { serverconfigs } from "../../constants";

export const fetchProcedureQuestionnaireStarted = () => {
  return {
    type: actionTypes.FETCH_PROCEDURE_QUESTIONNAIRE_STARTED,
  };
};
export const fetchProcedureQuestionnaireSuccess = (procedureQuestionnaire) => {
  procedureQuestionnaire.result = sortByOrder(procedureQuestionnaire.result);
  return {
    type: actionTypes.FETCH_PROCEDURE_QUESTIONNAIRE_SUCCESS,
    procedureQuestionnaire: procedureQuestionnaire,
  };
};
export const fetchProcedureQuestionnaireFailed = (error) => {
  return {
    type: actionTypes.FETCH_PROCEDURE_QUESTIONNAIRE_FAILED,
    payload: error,
  };
};

export const fetchProcedureQuestionnaire = () => {
  return (dispatch) => {
    dispatch(fetchProcedureQuestionnaireStarted());
    axios
      .get(serverconfigs.fetchProcedureQuestionnaireUrl)
      .then((response) => {
        console.log(response.data);
        dispatch(fetchProcedureQuestionnaireSuccess(response.data));
      })
      .catch((error) => {
        if (error.statusCode === 400) {
          logFirebaseEvent("Exception400");
        } else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
        }
        dispatch(fetchProcedureQuestionnaireFailed(error));
      });
  };
};
